module.exports = __webpack_public_path__ + "static/media/group-video-example.c20ff16a.svg";